import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationBulkDeleteResourcesArgs,
  BackendPerformanceCenterCustomerResource,
} from 'src/types/backend';

const MUTATION = gql`
  mutation BulkDeleteResource($ids: [ID!]!) {
    bulkDeleteResources(ids: $ids) {
      id
    }
  }
`;

type Variables = BackendMutationBulkDeleteResourcesArgs;
type Result = Pick<BackendPerformanceCenterCustomerResource, 'id'>[];

export const bulkDeleteResources = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
